import { AccredibleResponsiveMenuItem } from '@accredible-frontend-v2/components/responsive-menu';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { Component } from '@angular/core';

const TRANSLATION_KEY = 'directory_workato_com.header';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent {
  extraHeaderLinks: AccredibleResponsiveMenuItem[] = [
    {
      id: 'workato-app',
      label: this._language.selectTranslate(`${TRANSLATION_KEY}.app`),
      externalLink: 'https://app.workato.com/',
    },
    {
      id: 'workato-docs',
      label: this._language.selectTranslate(`${TRANSLATION_KEY}.docs`),
      externalLink: 'https://docs.workato.com/?utm_source=ai&utm_medium=referral',
    },
    {
      id: 'workato-website',
      label: this._language.selectTranslate(`${TRANSLATION_KEY}.workato_website`),
      externalLink: 'http://www.workato.com/',
    },
  ];
  extraLinksLoaded = false;

  constructor(private readonly _language: AccredibleLanguageService) {}
}
